/** venture/RepStrip.tsx — 보고 일정 한눈에: 연도별 줄에 상반기 정기 · 하반기 정기 · 결산 칩 (2026-09-24)
 *  칩 = 상태(✓ 완료 · ● 기간 중 · ! 지연 · ○ 예정) + 기간 + D-day. 누르면 그 보고 카드가 열린다. */
import React from 'react';
import type { RepPeriod } from './report';

interface Props { list: RepPeriod[]; today: string; activeKey: string; onPick: (key: string) => void; }

export const dday = (from: string, to: string, today: string, stat: RepPeriod['stat']): string => {
  const days = (a: string, b: string): number => Math.round((new Date(b + 'T00:00:00').getTime() - new Date(a + 'T00:00:00').getTime()) / 86400000);
  if (stat === 'done') return '완료';
  if (stat === 'due') { const d = days(today, to); return d === 0 ? '오늘 마감' : '마감 D-' + d; }
  if (stat === 'late') return days(to, today) + '일 지남';
  const d = days(today, from); return d <= 0 ? '곧 시작' : 'D-' + d + ' 시작';
};
const ICON: Record<RepPeriod['stat'], string> = { done: '✓', due: '●', late: '!', upcoming: '○' };
const short = (x: RepPeriod): string => (x.kind === 'annual' ? '결산' : x.half === 1 ? '상반기 정기' : '하반기 정기');
const mmdd = (iso: string): string => iso.slice(5).replace('-', '/');

export default function RepStrip({ list, today, activeKey, onPick }: Props) {
  const years = Array.from(new Set(list.map((x) => x.year))).sort();
  if (!years.length) return null;
  return (
    <div className="repstrip">
      {years.map((y) => (
        <div className="repstrip-y" key={y}>
          <span className="ry">{y}</span>
          {list.filter((x) => x.year === y).map((x) => (
            <button type="button" key={x.key} className={'rchip ' + x.stat + (activeKey === x.key ? ' active' : '')} onClick={() => onPick(x.key)} title={x.label + ' · ' + x.from + ' ~ ' + x.to}>
              <span className="ri">{ICON[x.stat]}</span>
              <span className="rt"><b>{short(x)}</b><small>{mmdd(x.from)}~{mmdd(x.to)}{x.from.slice(0, 4) !== String(y) ? ' (' + x.from.slice(0, 4) + ')' : ''}</small></span>
              <span className="rd">{dday(x.from, x.to, today, x.stat)}</span>
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}
